import React from 'react';

const PreviousResponse = ({ responseHeader, responseText }) => {
  return (
    <div className="previous-response">
      <div className="previous-response-header">
      <span className="label">{responseHeader}</span>
      <span className="previous-response-text">{responseText}</span>
      </div>
    </div>
  );
};

export default PreviousResponse;
